export class AppRoutes {
  public static readonly MAIN = 'main';
  public static readonly PRODUCT_DETAIL = `product`;
  public static readonly PROMO_DETAIL = `promocion`;
  public static readonly TIENDA = `${AppRoutes.MAIN}/Tienda`;
}
